import { func, number } from 'prop-types';
import React, { useEffect, useState } from 'react';
import HrbTranslate from '../../../components/language/HrbTranslate';
import Lang from '../../../components/language/services/Lang';
import districtsService from '../services/DistrictsService';

const OfficeListFilterHeader = props => {

    const { districtFilter, onFilterChanged } = props

    const [districtList, setDistrictList] = useState(null);

    const getDistrictList = async () => {
        var districtData = await districtsService.getDistricts()
        if (districtData) {
            setDistrictList(districtData)
        }
    }

    useEffect(() => {
        setDistrictList(null)
        getDistrictList()
    }, [])

    return (
        <div className="columns level px-3">
            <div className='column is-8'>
                <h3 className='mt-4'>
                    <HrbTranslate text='DistrictPage.PageTitle' />
                </h3>
            </div>
            <div className='column is-2'>
                <HrbTranslate text='DistrictPage.SelectDistrict' className='p1 is-pulled-right mt-4' />
            </div>
            <div className='column is-2'>
                <div className='select is-small is-pulled-right mt-4'>
                    <select id='sort-select-id' onChange={ev => onFilterChanged(ev.target.value)} value={districtFilter}>
                        <option value='-1'>{Lang.getCurrentValue('DistrictPage.AllDistricts')}</option>
                        {districtList && districtList.map((d, i) =>
                            <option key={i} value={`${d.id}`}>{`${d.name}`}</option>
                        )}
                    </select>
                </div>
            </div>
        </div>
    )
}

OfficeListFilterHeader.propTypes = {
    onFilterChanged: func,
    districtFilter: number
}

export default OfficeListFilterHeader